import { cn } from "../../lib/utils";
import { type SVGAttributes, forwardRef } from "react";
import { ICON_NAME_TO_KEBAB, type IconName } from "./icon-names.generated";

export type IconProps = Omit<SVGAttributes<SVGSVGElement>, "children"> & {
  src: IconName;
  size?: number;
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ src, size = 16, className, ...rest }, ref) => (
    <svg
      data-slot="icon"
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("inline-block shrink-0 align-middle", className)}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <use data-slot="icon-use" href={`#${ICON_NAME_TO_KEBAB[src]}`} />
    </svg>
  ),
);
Icon.displayName = "Icon";

export type { IconName };
